module.exports = __webpack_public_path__ + "img/fd0d04b.jpg";